// Firebase Configuration for Multiple Environments
import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAnalytics, logEvent } from 'firebase/analytics';

const firebaseConfigs = {
  development: {
    apiKey: "AIzaSyCj6wnd2a8YRJ2-zlgC56ZKHLnXB_U0fJk",
    authDomain: "realsightseerbackend-dev.firebaseapp.com",
    projectId: "realsightseerbackend-dev",
    storageBucket: "realsightseerbackend-dev.firebasestorage.app",
    messagingSenderId: "920078455554",
    appId: "1:920078455554:web:134d2fdafb41a54de4a81b",
    measurementId: "G-0XBZGNE5RF"
  },
  production: {
    apiKey: "AIzaSyBLYk9KdvVZ5sXMnryJVfH38J4LxGILc8Q",
    authDomain: "realsightseerbackend.firebaseapp.com",
    projectId: "realsightseerbackend",
    storageBucket: "realsightseerbackend.firebasestorage.app",
    messagingSenderId: "371859504451",
    appId: "1:371859504451:web:fe5b32d81d3ca9db6c5ac9",
    measurementId: "G-RES6VV22QX"
  }
};

// Determine environment based on hostname and environment variables
const getEnvironment = () => {
  // Allow explicit override via environment variable
  if (process.env.REACT_APP_ENVIRONMENT) {
    return process.env.REACT_APP_ENVIRONMENT;
  }

  const hostname = window.location.hostname;

  // Check for local development environments
  const isLocalDevelopment = (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    // Check for local network IPs (192.168.x.x, 10.x.x.x, 172.16-31.x.x)
    /^192\.168\.\d{1,3}\.\d{1,3}$/.test(hostname) ||
    /^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname) ||
    /^172\.(1[6-9]|2\d|3[01])\.\d{1,3}\.\d{1,3}$/.test(hostname)
  );

  // Development environments:
  // 1. localhost (local development)
  // 2. Local network IPs (for mobile device testing)
  // 3. Vercel development deployment
  if (
    isLocalDevelopment ||
    hostname === 'realworld-sightseer-react-userlingers-projects.vercel.app' ||
    hostname === 'realworld-sightseer-react-git-dev-userlingers-projects.vercel.app'
  ) {
    return 'development';
  }

  // Everything else is production
  return 'production';
};

const environment = getEnvironment();
const firebaseConfig = firebaseConfigs[environment];

// Log environment for debugging
console.log(`[Firebase] Using ${environment} environment`);
console.log(`[Firebase] Hostname: ${window.location.hostname}`);
console.log(`[Firebase] Project ID: ${firebaseConfig.projectId}`);

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Firebase services
const auth = getAuth(app);

// Determine if we should connect to local emulators
const isLocalDevelopment = (
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1' ||
  window.location.hostname.startsWith('192.168.') ||
  window.location.hostname.startsWith('10.') ||
  (window.location.hostname.startsWith('172.') &&
   (() => {
     const secondOctet = parseInt(window.location.hostname.split('.')[1], 10);
     return secondOctet >= 16 && secondOctet <= 31;
   })())
);

const useLocalEmulators = environment === 'development' && isLocalDevelopment;

// Use the named Firestore database everywhere.
const db = getFirestore(app, 'curio-users');

if (useLocalEmulators) {
  console.log('[Firebase] Connecting to local emulators');

  // Determine host (use page host for LAN access)
  const pageHost = window.location.hostname;
  const emulatorHost = pageHost === 'localhost'
    ? 'localhost'
    : pageHost;

  // Auth emulator
  try {
    connectAuthEmulator(auth, `http://${emulatorHost}:9099`, { disableWarnings: true });
    console.log(`[Firebase] Auth emulator connected at http://${emulatorHost}:9099`);
  } catch (e) {
    console.warn('[Firebase] Auth emulator connection skipped:', e.message);
  }

  // Firestore emulator
  try {
    connectFirestoreEmulator(db, emulatorHost, 8080);
    console.log(`[Firebase] Firestore emulator connected at ${emulatorHost}:8080 (curio-users database)`);
  } catch (e) {
    console.warn('[Firebase] Firestore emulator connection skipped:', e.message);
  }
} else {
  console.log('[Firebase] Using remote Firebase services (curio-users database)');
}

export { firebaseConfig, environment, app, auth, db, analytics, logEvent };
export default firebaseConfig;